import React from "react";
import SFTypography from "../typography";

const SFCarouselTitle = ({ children }) => (
  <SFTypography
    variant="courseCarouselTitle"
    sx={{
      paddingLeft: "80px",
    }}
  >
    {children}
  </SFTypography>
);

export default SFCarouselTitle;
